jQuery(document).ready(function () {
	if(document.getElementById("leafletMap")){
		const coords = [45.88306547813821, 13.717789358689176];
		const map = L.map('leafletMap',{
			center: coords,
			maxBounds: [
				[45.40895427906643, 13.353813934085492],
				[46.88509962223817, 16.624863694854234],
			],
			zoom: 15,
			maxZoom: 17,
			minZoom: 9,
			//maxBoundsViscosity: 1, // fully solid bounds
			zoomControl: true,
			scrollWheelZoom: false,
			dragging: true,
			
		});
		map.attributionControl.setPrefix('<a href="https://leafletjs.com" title="Leaflet - knjižnica JavaScript za interaktivne zemljevide" class="external" target="_blank">Leaflet</a>')
		
		L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
			attribution: ''
		}).addTo(map);

		const defaultIcon = L.icon({
			iconUrl: '/lib/leaflet/images/marker-icon.png',
			shadowUrl: '/lib/leaflet/images/marker-icon.png',
			iconSize:     [25, 45], // size of the icon
			iconAnchor:   [12.5, 45], // point of the icon which will correspond to marker's location
			popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
		});
		
		const marker = L.marker(coords, {icon: defaultIcon}).addTo(map);
	}
});